<span>
  Papertrail will charge the <strong>{{card_type}}</strong> ending in <strong>{{last_4}}</strong>
  on {{renewal_time}} &mdash;
</span>